// Energy is stored as integer watt-hours and money as integer cents, so sums
// never drift. Rates (dollars per kWh) keep four decimal places, as strings,
// because Postgres numeric comes back as a string and floats lose precision.

export const whToKwh = (wh: number): number => wh / 1000;
export const kwhToWh = (kwh: number): number => Math.round(kwh * 1000);

/** Cost in cents for an amount of energy at a $/kWh rate, rounded to the nearest cent. */
export function costCents(energyWh: number, ratePerKwh: string | number): number {
  const rate = typeof ratePerKwh === 'string' ? Number(ratePerKwh) : ratePerKwh;
  return Math.round((energyWh / 1000) * rate * 100);
}

/** GST component of a GST-inclusive amount (Australia, 10%). */
export const gstIncludedCents = (totalCents: number): number => Math.round(totalCents / 11);

const aud = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
export const formatCents = (cents: number): string => aud.format(cents / 100);

export const formatKwh = (wh: number, decimals = 2): string =>
  `${(wh / 1000).toLocaleString('en-AU', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })} kWh`;
